(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("foglet", [], factory);
	else if(typeof exports === 'object')
		exports["foglet"] = factory();
	else
		root["foglet"] = factory();
})(window, function() {
return 